import OutlineTwo from '@assets/icons/outline-two.svg'
import { Icon } from './Icon'

export const OutlineTwoIcon = Icon(OutlineTwo)
